import { Link } from "react-router-dom"
import { Home } from "lucide-react"
import { Button } from "@/components/ui/button"

export default function NotFound() {
  return (
    <div className="flex-1 flex items-center justify-center px-4 py-16">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-muted-foreground/30">404</h1>
        <h2 className="text-xl font-bold text-foreground mt-4">Page not found</h2>
        <p className="text-muted-foreground mt-2">The page you're looking for doesn't exist.</p>
        <Link to="/" className="inline-block mt-6">
          <Button className="bg-primary hover:bg-primary-dark text-white rounded-xl font-semibold">
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  )
}
